const NAME = "MY_ONBOARDING_TRACKING";

export default NAME;
